import * as classnames from 'classnames/bind'
import * as React from 'react'
import buttonStyles from '../../components/Button/button.scss'
import recruitMock1 from '../../images/common/recruit-mock/recruit-mock-1.svg'
import recruitMock2 from '../../images/common/recruit-mock/recruit-mock-2.svg'
import recruitMock3 from '../../images/common/recruit-mock/recruit-mock-3.svg'
import recruitMock4 from '../../images/common/recruit-mock/recruit-mock-4.svg'
import BasicLayout from '../../layouts/BasicLayout'
import styles from './recruit-page.scss'


const cx = classnames.bind({ ...styles, ...buttonStyles })


class RecruitPage extends React.Component {


  public render() {
    return (
      <BasicLayout>
        <div className={cx('wrapper', 'expert-page')}>

          {/* <!-- Start main --> */}
          <section className={cx('main')}>

            {/* <!-- Start jumbotron --> */}
            <div className={cx('jumbotron')}>
              <div className={cx('bg-size-fixed')} />
              <div className={cx('container')}>
                <div className={cx('row')}>
                  <div className={cx('col-10', 'col-sm-9', 'col-md-6', 'col-lg-7')}>
                    <h1 className={cx('jumbotron__heading', 'color--white')}>首創互動式講座</h1>
                    <p className={cx('jumbotron__para', 'heading-5', 'color--white')}>在 Qraft 上成為專業講師，讓知識不被刻意包裝就能賺取收入
                    <br className={cx('u-mobile-hidden')} />不需要額外寫腳本、搭棚拍攝影片，半小時就能夠上架</p>
                    <div className={cx('application-form')}>
                      <a href="https://louissyue1.typeform.com/to/RQ22jS" target="_blank" className={cx('btn', 'btn--primary', 'btn--md', 'btn--fluid', 'u-font-weight-600', 'u-font-size-18')}>獨家合作</a>
                    </div>
                  </div>
                  <div className={cx('col-md-6')} />
                </div>
              </div>
            </div>
            {/* <!-- End jumbotron --> */}

            {/* <!-- Start about --> */}
            <div className={cx('index-about')}>
              <div className={cx('bg-yellow-light')} />
              <div className={cx('container')}>
                <div className={cx('row', 'align-items-center', 'item-container')}>
                  <div className={cx('col-md-6', 'order-2', 'order-sm-2', 'order-md-1')}>
                    <div className={cx('text-container')}>
                      <h3 className={cx('title heading-3')}>分享讓知識變得獨特</h3>
                      <p className={cx('heading-5')}>在 Qraft 延續你每個知識的價值<br className={cx('mobile-hidden')} />透過講座中的交流，讓經驗總結成知識</p>
                    </div>
                  </div>
                  <div className={cx('col-md-6', 'order-1', 'order-sm-1', 'order-md-2')}>
                    <div className={cx('svg-container')}>
                      <img src={recruitMock1} alt="" />
                    </div>
                  </div>
                </div>
                <div className={cx('row', 'align-items-center', 'item-container')}>
                  <div className={cx('col-md-6', 'order-2', 'order-sm-2', 'order-md-2')}>
                    <div className={cx('text-container')}>
                      <h3 className={cx('title', 'heading-3')}>碎片知識系統化</h3>
                      <p className={cx('heading-5')}>累積讓每個知識更有價值，不論是在商業、法律、生活...<br className={cx('mobile-hidden')} />我們讓每個內容、解答系統化，儲存在你的專屬知識庫</p>
                    </div>
                  </div>
                  <div className={cx('col-md-6', 'order-1', 'order-sm-1', 'order-md-1')}>
                    <div className={cx('svg-container')}>
                      <img src={recruitMock2} alt="" />
                    </div>
                  </div>
                </div>
                <div className={cx('row', 'align-items-center', 'item-container')}>
                  <div className={cx('col-md-6', 'order-2', 'order-sm-2', 'order-md-1')}>
                    <div className={cx('text-container')}>
                      <h3 className={cx('title', 'heading-3')}>零碎時間也能賺取收入</h3>
                      <p className={cx('heading-5')}>只要一個講座的內容，讓累積的知識上架創造被動收入<br className={cx('mobile-hidden')} />就連交通時間，與人交流知識都能增加收入</p>
                    </div>
                  </div>
                  <div className={cx('col-md-6', 'order-1', 'order-sm-1', 'order-md-2')}>
                    <div className={cx('svg-container')}>
                      <img src={recruitMock3} alt="" />
                    </div>
                  </div>
                </div>
                <div className={cx('row', 'align-items-center', 'item-container')}>
                  <div className={cx('col-md-6')}>
                    <div className={cx('svg-container')}>
                      <img src={recruitMock4} alt="" />
                    </div>
                  </div>
                  <div className={cx('col-md-6')}>
                    <div className={cx('text-container')}>
                      <h3 className={cx('title heading-3')}>社交價值讓 Qraft 幫您量化</h3>
                      <p className={cx('heading-5')}>在 Qraft 記錄你每次專業的答覆、每條精心的內容，<br className={cx('mobile-hidden')} />都值得被反覆聽取，共享知識社群的價值。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- End about --> */}

            {/* <!-- Start contact --> */}
            <div className={cx('index-contact')}>
              <div className={cx('fluid-dialog')}>
                <div className={cx('dialog', 'dialog-1')}>
                  {/* <?xml version="1.0" encoding="UTF-8"?> */}
                  <svg width="530px" height="206px" viewBox="0 0 530 206" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    {/* <!-- Generator: Sketch 50 (54983) - http://www.bohemiancoding.com/sketch --> */}
                    <title>message1</title>
                    <desc>Created with Sketch.</desc>
                    <defs />
                    <g id="message1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.268669577">
                      <g id="Group-11-Copy-2">
                        <path d="M7.2,-1.27897692e-13 L522.72,-1.28785871e-13 C526.69645,-6.59439823e-14 529.92,3.2235498 529.92,7.2 L529.92,138.969105 C529.92,142.945555 526.69645,146.169105 522.72,146.169105 L477.232981,146.169105 L477.232981,205.92 L407.97607,146.169105 L7.2,146.169105 C3.2235498,146.169105 -1.01711663e-14,142.945555 -1.0658141e-14,138.969105 L-8.8817842e-16,7.2 C-3.14105175e-15,3.2235498 3.2235498,-1.25390874e-13 7.2,-1.26121336e-13 Z" id="Rectangle-9" fill="#FFFFFF" transform="translate(264.960000, 102.960000) scale(-1, 1) translate(-264.960000, -102.960000) " />
                        <text id="要如何開始學寫程式" fontFamily="PingFangTC-Medium, PingFang TC" fontSize="34.56" fontWeight="400" letterSpacing="0.414719975" fill="#4A4A4A">
                          <tspan x="71" y="93">要如何開始學寫程式</tspan>
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className={cx('dialog', 'dialog-2')}>
                  {/* <?xml version="1.0" encoding="UTF-8"?> */}
                  <svg width="334px" height="130px" viewBox="0 0 334 130" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    {/* <!-- Generator: Sketch 50 (54983) - http://www.bohemiancoding.com/sketch --> */}
                    <title>message2</title>
                    <desc>Created with Sketch.</desc>
                    <defs />
                    <g id="message2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.29296875">
                      <g id="Group-14-Copy">
                        <path d="M6.048,-1.27897692e-13 L327.8016,-1.28785871e-13 C331.141818,-1.29399459e-13 333.8496,2.70778183 333.8496,6.048 L333.8496,85.8816 C333.8496,89.2218182 331.141818,91.9296 327.8016,91.9296 L300.656778,91.9296 L300.656778,129.508511 L257.024924,91.9296 L6.048,91.9296 C2.70778183,91.9296 1.04903682e-14,89.2218182 2.66453526e-15,85.8816 L0,6.048 C-4.09058749e-16,2.70778183 2.70778183,-1.31724996e-13 6.048,-1.32338585e-13 Z" id="Rectangle-9-Copy" fill="#FFFFFF" transform="translate(166.924800, 64.754256) scale(-1, 1) translate(-166.924800, -64.754256) " />
                        <text id="明天就要去面試了，怎麼講比較好" fontFamily="PingFangTC-Medium, PingFang TC" fontSize="19.3536" fontWeight="400" letterSpacing="0.23224318" fill="#4A4A4A">
                          <tspan x="20.5632" y="52.4496">明天就要去面試了，怎麼講比較好</tspan>
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className={cx('dialog', 'dialog-3')}>
                  {/* <?xml version="1.0" encoding="UTF-8"?> */}
                  <svg width="399px" height="156px" viewBox="0 0 399 156" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    {/* <!-- Generator: Sketch 50 (54983) - http://www.bohemiancoding.com/sketch --> */}
                    <title>message3</title>
                    <desc>Created with Sketch.</desc>
                    <defs />
                    <g id="message3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.210477941">
                      <g id="Group-13-Copy" transform="translate(0.120000, 0.360000)">
                        <path d="M7.2,-1.27897692e-13 L390.24,-1.35891298e-13 C394.21645,-1.3662176e-13 397.44,3.2235498 397.44,7.2 L397.44,102.24 C397.44,106.21645 394.21645,109.44 390.24,109.44 L357.924736,109.44 L357.924736,154.176799 L305.982052,109.44 L7.2,109.44 C3.2235498,109.44 -1.10593448e-14,106.21645 -1.15463195e-14,102.24 L0,7.2 C-4.86974701e-16,3.2235498 3.2235498,-1.24502695e-13 7.2,-1.25233157e-13 Z" id="Rectangle-9-Copy-2" fill="#FFFFFF" transform="translate(198.720000, 77.088400) scale(-1, -1) translate(-198.720000, -77.088400) " />
                        <text id="我根本不想相親啊-…" fontFamily="PingFangTC-Medium, PingFang TC" fontSize="23.04" fontWeight="400" letterSpacing="0.276479995" fill="#4A4A4A">
                          <tspan x="86.4" y="110.4">我根本不想相親啊 … </tspan>
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className={cx('dialog', 'dialog-4')}>
                  {/* <?xml version="1.0" encoding="UTF-8"?> */}
                  <svg width="530px" height="206px" viewBox="0 0 530 206" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    {/* <!-- Generator: Sketch 50 (54983) - http://www.bohemiancoding.com/sketch --> */}
                    <title>message4</title>
                    <desc>Created with Sketch.</desc>
                    <defs />
                    <g id="message4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.182157629">
                      <g id="Group-11-Copy">
                        <path d="M7.2,-1.27897692e-13 L522.72,-1.28785871e-13 C526.69645,-6.59439823e-14 529.92,3.2235498 529.92,7.2 L529.92,138.969105 C529.92,142.945555 526.69645,146.169105 522.72,146.169105 L477.232981,146.169105 L477.232981,205.92 L407.97607,146.169105 L7.2,146.169105 C3.2235498,146.169105 -1.01711663e-14,142.945555 -1.0658141e-14,138.969105 L-8.8817842e-16,7.2 C-3.14105175e-15,3.2235498 3.2235498,-1.25390874e-13 7.2,-1.26121336e-13 Z" id="Rectangle-9" fill="#FFFFFF" />
                        <text id="學日文一直卡在文法句型-...." fontFamily="PingFangTC-Medium, PingFang TC" fontSize="23.04" fontWeight="400" letterSpacing="0.276479995" fill="#4A4A4A">
                          <tspan x="70.56" y="74.4">學日文一直卡在文法句型 ....</tspan>
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className={cx('dialog', 'dialog-5')}>
                  {/* <?xml version="1.0" encoding="UTF-8"?> */}
                  <svg width="399px" height="156px" viewBox="0 0 399 156" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    {/* <!-- Generator: Sketch 50 (54983) - http://www.bohemiancoding.com/sketch --> */}
                    <title>message5</title>
                    <desc>Created with Sketch.</desc>
                    <defs />
                    <g id="message5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.0850758272">
                      <g id="Group-11" transform="translate(0.200000, 0.600000)">
                        <g id="Group-19">
                          <path d="M7.2,-1.27897692e-13 L390.24,-1.35891298e-13 C394.21645,-1.3662176e-13 397.44,3.2235498 397.44,7.2 L397.44,102.24 C397.44,106.21645 394.21645,109.44 390.24,109.44 L357.924736,109.44 L357.924736,154.176799 L305.982052,109.44 L7.2,109.44 C3.2235498,109.44 -1.10593448e-14,106.21645 -1.15463195e-14,102.24 L0,7.2 C-4.86974701e-16,3.2235498 3.2235498,-1.24502695e-13 7.2,-1.25233157e-13 Z" id="Rectangle-9" fill="#FFFFFF" />
                          <text id="學日文一直卡在文法句型-...." fontFamily="PingFangTC-Medium, PingFang TC" fontSize="23.04" fontWeight="400" letterSpacing="0.276479995" fill="#4A4A4A">
                            <tspan x="53.28" y="61.44">學日文一直卡在文法句型 ....</tspan>
                          </text>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className={cx('dialog', 'dialog-6')}>
                  {/* <?xml version="1.0" encoding="UTF-8"?> */}
                  <svg width="398px" height="140px" viewBox="0 0 398 140" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    {/* <!-- Generator: Sketch 50 (54983) - http://www.bohemiancoding.com/sketch --> */}
                    <title>message6</title>
                    <desc>Created with Sketch.</desc>
                    <defs />
                    <g id="message6" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Group-20">
                        <g id="Group-10" opacity="0.198644301" fill="#FFFFFF">
                          <path d="M7.2,-5.40012479e-13 L390.24,-5.40900658e-13 C394.21645,-5.73417295e-13 397.44,3.2235498 397.44,7.2 L397.44,102.24 C397.44,106.21645 394.21645,109.44 390.24,109.44 L241.752944,109.44 L241.752944,139.127741 L185.830886,109.44 L7.2,109.44 C3.2235498,109.44 4.84486094e-14,106.21645 4.79616347e-14,102.24 L-1.77635684e-15,7.2 C-4.02923017e-15,3.2235498 3.2235498,-5.40170196e-13 7.2,-5.40900658e-13 Z" id="Rectangle-9-Copy-4" />
                        </g>
                        <text id="我要怎麼運用哲學解決問題" opacity="0.300000012" fontFamily="PingFangTC-Medium, PingFang TC" fontSize="20" fontWeight="400" letterSpacing="0.960000098" fill="#4A4A4A">
                          <tspan x="73" y="63">我要怎麼運用哲學解決問題</tspan>
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
              <div className={cx('container')}>
                <div className={cx('application-form')}>
                  <a href="https://louissyue1.typeform.com/to/RQ22jS" target="_blank" className={cx('btn', 'btn--primary', 'btn--md', 'btn--fluid')}>搶先加入專家陣營</a>
                </div>
              </div>
            </div>

          </section>
          {/* <!-- End main --> */}
        </div>
      </BasicLayout>
    )
  }
}

export default RecruitPage


// WEBPACK FOOTER //
// ./src/pages/RecruitPage/index.tsx